// Its own module so neither the toggle nor the row has to import the other.
export const VIEW_KEY_ROW_ID = 'view-key-row';
